import {
  RoadmapExpertParameter as Data,
  RoadmapExpertParameterCollection as Collection,
} from '@/typings/api/Roadmap/Experts/Parameters'
import { RoadmapExpertCriteria } from '@/typings/api/Roadmap/Experts/Criteria'

import { BaseApiAuth } from '@/api/BaseApiAuth'
import { BaseApiParams } from '@/typings/common'


interface RoadmapExpertsParametersApiParams extends BaseApiParams {
  criterion_id: RoadmapExpertCriteria['id'];
}


export class RoadmapExpertsParametersApi extends BaseApiAuth<Data, Collection, RoadmapExpertsParametersApiParams> {
  protected readonly endpoint = 'publications/roadmap_experts/parameters';
}
